import { Component, Input, OnDestroy, OnInit} from "@angular/core";
import * as moment from "moment";
import * as _ from "underscore";
import { Subject, Subscription, fromEvent } from "rxjs";
import { debounceTime, distinctUntilChanged, map } from "rxjs/operators";
import { ApiService } from "app/modules/shared/services/api.service";
import { AnalyticService } from "app/modules/shared/services/analytic.service";
import { Router } from "@angular/router";
import * as FileSaver from "file-saver";

@Component({
  selector: 'app-stars-lessons-consolidated-count-analtics',
  templateUrl: './stars-lessons-consolidated-count-analtics.component.html',
  styleUrls: ['./stars-lessons-consolidated-count-analtics.component.scss']
})
export class StarsLessonsConsolidatedCountAnalticsComponent implements OnInit, OnDestroy {
  @Input() selectedApp: any;
  @Input() dateData$: Subject<any>;
  listDateRange: any = "daySelected";
  listDates: any = "";
  //dataList: any;
  dataList: any ={
    "totalSessionPlayed": 0,
    "averageDuration": 0,
    "totalDuration": 0
};
  date: any;
  dateInfo: any;
  subsink: Subscription;
  dateType: any = { type: "Month" };

  constructor(public analyticService: AnalyticService, public router: Router, public api: ApiService) {}

  ngOnInit() {
    //this.subsink = this.dateData$.pipe(debounceTime(500), distinctUntilChanged()).subscribe((v) => {
    /*this.subsink = this.api.dateRange$.pipe(debounceTime(500), distinctUntilChanged()).subscribe((v) => {
      if (v) {
        this.dateInfo = v;
        this.triggerDateSelection(v);
      }
    });*/
  }

  ngAfterViewInit() {
    /*this.subsink = this.api.dateRange$.pipe(debounceTime(500), distinctUntilChanged()).subscribe((v) => {
      if (v) {
        console.log("v>>>>>>>>>>>>>>>>>>>>" + JSON.stringify(v));
        this.dateInfo = v;
        this.triggerDateSelection(v);
      }
    });*/

    this.subsink = this.api.dateRange$.pipe(debounceTime(500), distinctUntilChanged()).subscribe((next) => {
          if (next) {
            this.dateInfo = localStorage.getItem("dateRange");
            if (this.dateInfo) {
              next = JSON.parse(this.dateInfo);
            }
            //this.dateType = next;
            this.triggerDateSelection(next);
          }
    });
  }

  triggerDateSelection(data) {
    switch (data.type) {
      case "Day": {
        this.daySelected();
        break;
      }
      case "Month": {
        this.monthSelected();
        break;
      }
      case "Year": {
        this.yearSelected();
        break;
      }
      case "range": {
        this.rangeSelected(data);
        break;
      }
    }
  }

  daySelected() {
    this.consolidatedRatioSelected("daySelected");

    // Set the calendar range to the last 31 days
    const currentDate = new Date();
    const startDate = new Date();
    startDate.setDate(currentDate.getDate() - 30);

    this.date = {
      startDate: startDate,
      endDate: currentDate,
    };
  }

  monthSelected() {
    this.consolidatedRatioSelected("monthSelected");

    // Set the calendar range to show the last 2 years
    const today = new Date();
    const twoYearsAgo = new Date(today.getFullYear() - 2, today.getMonth(), today.getDate());
    this.date = {
      startDate: twoYearsAgo,
      endDate: today,
    };
  }

  yearSelected() {
    this.consolidatedRatioSelected("yearSelected");
    const today = new Date();
    const fourYearsAgo = new Date(today.getFullYear() - 5, today.getMonth(), today.getDate());
    this.date = {
      startDate: fourYearsAgo,
      endDate: today,
    };
  }

  rangeSelected(result) {
    let startDate = moment(result.startDate).format("YYYY-MM-DD");
    let endDate = moment(result.endDate).format("YYYY-MM-DD");
    this.consolidatedRatioOnDateRange(startDate, endDate);
    this.date = {
      startDate: startDate,
      endDate: endDate,
    };
  }

  consolidatedRatioSelected(data) {
    let selectData: string = "";
    if (data == "daySelected") {
      this.listDateRange = "daySelected";
      selectData = "day";
      this.listDates = moment(new Date()).subtract(1, "d").format("YYYY-MM-DD") + " To " + moment(new Date()).format("YYYY-MM-DD");
    } else if (data == "monthSelected") {
      this.listDateRange = "monthSelected";
      selectData = "month";
      this.listDates = moment(new Date()).subtract(1, "M").format("YYYY-MM-DD") + " To " + moment(new Date()).format("YYYY-MM-DD");
    } else if (data == "yearSelected") {
      this.listDateRange = "yearSelected";
      selectData = "year";
      this.listDates = moment(new Date()).subtract(1, "y").format("YYYY-MM-DD") + " To " + moment(new Date()).format("YYYY-MM-DD");
    }
    this.analyticService.getStarsConsolidatedTotalData(selectData, this.selectedApp.id, null, this.selectedApp.dataId).subscribe(
      (res) => {
        this.dataList = res;
      },
      (err) => {
        this.api.getError(err);
      }
    );
  }

  consolidatedRatioOnDateRange(startDate, endDate) {
    this.analyticService.getStarsDifficultPOnDateRangeConsolidatedTotal(startDate, endDate, this.selectedApp.id, null, this.selectedApp.dataId).subscribe(
      (res) => {
        this.dataList = res;
      },
      (err) => {
        this.api.getError(err);
      }
    );
  }

  isFiniteNumber(value: number): boolean {
    return isFinite(value);
  }

  async exportCsvData(analyticsType) {
    let dateType;
    if (this.listDateRange == "daySelected") dateType = "day";
    else if (this.listDateRange == "monthSelected") dateType = "month";
    else if (this.listDateRange == "yearSelected") dateType = "year";
    else if (this.listDateRange == "rangeSelected") {
      dateType = "range";
    }
    let requestParam = "";
    try {
      this.analyticService.getCsvData(analyticsType, dateType, this.date.startDate, this.date.endDate, this.selectedApp.id, requestParam, null).subscribe(
        (data) => {
          let dataObject: any = data;
          if (data.type === "application/zip") {
            var blob = new Blob([data], { type: data.type });
            FileSaver.saveAs(blob, analyticsType.toUpperCase() + ".zip");
          } else {
            var blob = new Blob([data], { type: "application/csv" });
            FileSaver.saveAs(blob, analyticsType.toUpperCase() + ".csv");
          }
        },
        (err) => {
          this.api.getError(err);
        }
      );
    } catch (error) {}
  }
  // ***********  SG-7203 start*************************

  ngOnDestroy(): void {
    if (this.subsink) {
      this.subsink.unsubscribe();
    }
  }
  // ***********  SG-7203 end*************************
}
